module.exports = __webpack_public_path__ + "img/logo-v.90846c77.png";